import { styled } from "@mui/material/styles";
import {
  TableContainer,
  TableRow,
  TableCell,
  Button,
  Box,
  Paper,
  Chip,
  Typography,
} from "@mui/material";
import { colors, fonts } from "../../../../../theme/theme";

export const DateTimeDateText = styled(Typography)({
  fontWeight: 600,
  fontSize: "inherit",
  fontFamily: "inherit",
});

export const DateTimeTimeText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.75rem",
}));

export const ChipPaid = styled(Chip)({
  backgroundColor: "#4CAF50",
  color: "white",
  fontWeight: 600,
  fontFamily: fonts.gotham,
  "& .MuiChip-label": { fontFamily: fonts.gotham, fontWeight: 600 },
});

export const ChipPast = styled(Chip)({
  backgroundColor: "transparent",
  color: "#666",
  fontWeight: 600,
  fontFamily: fonts.gotham,
  border: "1px solid #666",
  "& .MuiChip-label": { fontFamily: fonts.gotham, fontWeight: 600 },
});

export const ChipFreeConsultation = styled(Chip)({
  backgroundColor: "#8B4513",
  color: "white",
  fontWeight: 600,
  fontFamily: fonts.gotham,
  "& .MuiChip-label": { fontFamily: fonts.gotham, fontWeight: 600 },
});

export const ChipPaymentPending = styled(Chip)({
  backgroundColor: "#FF9800",
  color: "white",
  fontWeight: 600,
  fontFamily: fonts.gotham,
  "& .MuiChip-label": { fontFamily: fonts.gotham, fontWeight: 600 },
});

export const ChipFollowUpOutlined = styled(Chip)({
  fontFamily: fonts.gotham,
  fontWeight: 600,
  "& .MuiChip-label": { fontFamily: fonts.gotham, fontWeight: 600 },
});

export const CardIndexBadge = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  fontSize: 16,
  fontWeight: 600,
  color: colors.primary,
  opacity: 0.5,
}));

export const AppointmentCardPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "isUpcomingSession",
})(({ theme, isUpcomingSession }) => ({
  position: "relative",
  padding: theme.spacing(2),
  cursor: "pointer",
  opacity: isUpcomingSession ? 1 : .8,
  "&:hover": { backgroundColor: "rgba(0,0,0,0.02)" },
}));

export const AppointmentCardGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(1),
  alignItems: "center",
}));

export const MobileListBox = styled(Box)(({ theme }) => ({
  display: "grid",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  gap: theme.spacing(1.5),
  [theme.breakpoints.down(1050)]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.down(650)]: {
    gridTemplateColumns: "1fr",
  },
}));

export const StyledTableContainer = styled(TableContainer)({
  borderRadius: "14px",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  border: `1px solid ${colors.primary}20`,
});

export const StyledHeaderRow = styled(TableRow)({
  backgroundColor: colors.headerBg,
});

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 14,
  color: colors.primary,
  fontFamily: "'Gotham', sans-serif",
  [theme.breakpoints.down("sm")]: {
    padding: 10,
    fontSize: 10,
  },
}));

const INACTIVE_STATUSES = ["cancelled", "noshow", "no_show"];
const COMPLETED_STATUSES = ["showed", "completed"];

export const StyledBodyRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "status" && prop !== "isUpcomingSession",
})(({ status, isUpcomingSession }) => {
  const statusLower = status?.toLowerCase() || "";
  const isInactive = INACTIVE_STATUSES.includes(statusLower) || !isUpcomingSession;
  const isCompleted = COMPLETED_STATUSES.includes(statusLower);

  return {
    backgroundColor: "#FAFAFA",
    "&:hover": { cursor: "pointer" },
    ...(isInactive && { opacity: 0.55 }),
    ...(isCompleted && { opacity: 0.75 }),
  };
});

export const StyledBookFollowUpBtn = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "14px",
  px: 2,
  py: 0.75,
  borderColor: colors.primary,
  color: colors.primary,
  fontFamily: "'Gotham', sans-serif",
  "&:hover": {
    borderColor: colors.primary,
    backgroundColor: `${colors.primary}10`,
  },
  [theme.breakpoints.down("sm")]: {
    padding: 10,
    fontSize: 10,
    lineHeight: ".8rem",
  },
}));

export const StyledBodyCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "applyStyles",
})(({ applyStyles, theme }) => ({
  ...(applyStyles && {
    fontWeight: 500,
    color: colors.primary,
    fontFamily: "'Gotham', sans-serif",
  }),
  [theme.breakpoints.down("sm")]: {
    padding: 10,
    fontSize: 10,
  },
}));
